// Copy-to-clipboard for the "Embed this tool" snippet on /tools/<slug> pages.
// Each copy button carries data-embed-copy="<selector>" pointing at the
// textarea holding the snippet. No-op when no snippet is on the page.

export function setupEmbedSnippet() {
  if (typeof document === "undefined") return
  document.querySelectorAll("[data-embed-copy]").forEach((btn) => {
    btn.addEventListener("click", async () => {
      const field = document.querySelector(btn.getAttribute("data-embed-copy"))
      if (!field) return
      const done = (label) => {
        const original = btn.dataset.label || btn.textContent
        btn.dataset.label = original
        btn.textContent = label
        setTimeout(() => { btn.textContent = original }, 2000)
      }
      try {
        await navigator.clipboard.writeText(field.value)
        done("Copied")
      } catch {
        // Clipboard API blocked (insecure context, denied permission): fall
        // back to selecting the text so the user can copy it manually.
        field.removeAttribute("readonly")
        field.select()
        field.setAttribute("readonly", "readonly")
        done("Press Ctrl+C")
      }
    })
  })
}
